import React from 'react';

import { TransactionCardsList } from '@/components/transaction-card-list';

export const DashboardPage = () => <TransactionCardsList />;

export default DashboardPage
